
  <div class="row contenedor_tabla">
     <div class="col-12">

        <kendo-grid   *ngIf="!_tablaSearchService.isLoading"
        #grid
        class="home-grid"
        [data]="_tablaSearchService.dataBoxResults"
        [height]="300"
        [selectable]="true"
        (cellClick)="clickElement($event)"
        >
          <kendo-grid-column field="LinkedCode"
           title="{{ 'gestion_terceros.identificationData.arcadCode' | translate }}"
           width="200"
           [headerStyle]="headerStyle"
           [class]="{'codeColumn': true}">
          </kendo-grid-column>

          <kendo-grid-column field="CompanyName"
           title="{{ 'labels.name' | translate }}"
           width="100" [headerStyle]="headerStyle"
           [class]="{'codeColumn': true}">
          </kendo-grid-column>

          <ng-template kendoGridNoRecordsTemplate>
                {{ 'genericos.messagesKendo.noDataAvailableNo' | translate }}
          </ng-template>

        </kendo-grid>
        <div *ngIf="_tablaSearchService.isLoading" class="kendo-loading">
          <span class="k-icon k-i-loading small"></span>
        </div>
    </div>
  </div>
